export var aopOrderbookClientDetails = function (data) {
    var aopOrderbookDetails = {
        application_details: null,
        order_details: null,
        account_details: null,
        quality_check_details: null,
        customer_kyc_deatils: null,
    };
    if (!!data && data !== "") {
        var mainData = JSON.parse(data);
        aopOrderbookDetails.account_details = mainData.account_details;
        aopOrderbookDetails.order_details = mainData.order_details;
        aopOrderbookDetails.quality_check_details = mainData.quality_check_details;
        aopOrderbookDetails.customer_kyc_deatils = mainData.customer_kyc_deatils;
        aopOrderbookDetails.application_details = mainData.application_details;
    }
    return aopOrderbookDetails;
};
